import * as angular from 'angular';
import Quill from 'quill';

const QUILL_EDITOR_TEMPLATE = `
  <div class="text-editor"></div>
`;

const quillOptions = {
  modules: {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'strike', 'link'],
      [{ align: [] }, { list: 'ordered' }, { list: 'bullet' }, 'code-block'],
      ['clean'],
      ['image'],
    ],
  },
  placeholder: 'Double click to edit...',
  theme: 'snow',
};

export default class QuillEditorModule {
  opt: {
    textContents: string;
    isEditing: boolean;
    onClickRemove: () => void;
    onTextChange: () => void;
  };
  textContents: string;
  isEditing: boolean;
  onClickRemove: () => void;
  onTextChange: (contents: string) => void;
  quillOptions: any;
  quillEditor: any;
  $el: JQuery;
  $toolbar: JQuery;
  $body: JQuery;
  onEdit: () => void;

  constructor(opt) {
    this.opt = opt;
    this.quillOptions = quillOptions;
    this.isEditing = this.opt.isEditing;
    this.textContents = this.opt.textContents;
    this.onClickRemove = this.opt.onClickRemove ? this.opt.onClickRemove : () => {};
    this.onTextChange = this.opt.onTextChange ? this.opt.onTextChange : () => {};
    this.onEdit = this.setEditMode;

    this.$el = $(QUILL_EDITOR_TEMPLATE);
    this.$body = $(document.body);

    this.init();
  }

  checkBounds(elem) {
    const rightOffset = elem[0].getBoundingClientRect().right;
    if (window.innerWidth - rightOffset < 0) {
      elem.addClass('is-out-of-view');
    } else {
      elem.removeClass('is-out-of-view');
    }
  }

  focus() {
    this.quillEditor.focus();
  }

  bindBlurEvents() {
    const containsTarget = ($el, target) => $.contains($el.get(0), target);

    this.$body.on('click.textBlock', (evt) => {
      if (!containsTarget(this.$el, evt.target) && !containsTarget(this.$toolbar, evt.target)) {
        this.setViewMode();
      }
    });

    this.$body.on('keyup.textBlock', (evt) => {
      // esc key handling
      if (evt.keyCode === 27) {
        this.setViewMode();
      }
    });
  }

  unbindBlurEvents() {
    this.$body.off('click.textBlock');
    this.$body.off('keyup.textBlock');
  }

  setViewMode() {
    this.$toolbar.find('.text-block-size-dropdown').removeClass('active');
    this.$toolbar.hide();
    this.$toolbar.removeClass('is-out-of-view');
    this.$el.removeClass('edit-mode');
    this.$el.addClass('view-mode');
    this.$el.parent().addClass('chart-content');
    this.quillEditor.disable();
    this.quillEditor.blur();
    if (this.quillEditor.getText().trim() === '') {
      this.quillEditor.root.dataset.placeholder = 'Double click to edit...';
    }
    if (!this.isEditing) {
      this.quillEditor.root.dataset.placeholder = '';
    }

    this.unbindBlurEvents();
  }

  setEditMode() {
    this.$toolbar.show();
    this.$el.removeClass('view-mode');
    this.$el.addClass('edit-mode');
    this.$el.parent().removeClass('chart-content');
    this.quillEditor.enable();
    this.quillEditor.root.dataset.placeholder = '';
    this.checkBounds(this.$toolbar);

    const range = this.quillEditor.getSelection();
    if (range) {
      if (range.length === 1) {
        this.quillEditor.setSelection(range.index, 0);
      } else {
        this.quillEditor.setSelection(range.index, range.length);
      }
    }

    this.bindBlurEvents();
  }

  init() {
    this.quillEditor = new Quill(this.$el[0], this.quillOptions);
    this.$toolbar = $(this.quillEditor.getModule('toolbar').container);

    this.$el.on('dblclick', (evt) => {
      if (!this.isEditing) {
        return;
      }
      if (!this.$el.hasClass('edit-mode')) {
        this.setEditMode();
      }
    });

    this.quillEditor.on('text-change', (delta, oldContents, source) => {
      if (source === 'user') {
        this.onTextChange(this.quillEditor.getSemanticHTML());
      }
    });
  }

  postInit() {
    if (this.textContents && this.textContents.length) {
      this.quillEditor.root.dataset.placeholder = '';
      this.quillEditor.clipboard.dangerouslyPasteHTML(this.textContents, 'silent');
    }

    if (!this.isEditing) {
      this.setViewMode();
      window.scrollTo(0, 0);
      return;
    }

    if (angular.isUndefined(this.textContents)) {
      this.focus();
      this.setEditMode();
    } else {
      this.setViewMode();
      window.scrollTo(0, 0);
    }
  }
}
